var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pl-2 search-values"},[_vm._v(" "+_vm._s(_vm.$t('knowledge.product.search-results', { resultCount: _vm.resultCount, searchFilter: _vm.searchFilter, }))+" "),_c('font-awesome-icon',{staticClass:"delete-icon",attrs:{"icon":['fal', 'times']},on:{"click":function($event){return _vm.$emit('reset-search')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }